import { render, staticRenderFns } from "./EligibilityNotMetD2CLandlord.vue?vue&type=template&id=010066b7&scoped=true&"
import script from "./EligibilityNotMetD2CLandlord.vue?vue&type=script&lang=js&"
export * from "./EligibilityNotMetD2CLandlord.vue?vue&type=script&lang=js&"
import style0 from "./EligibilityNotMetD2CLandlord.vue?vue&type=style&index=0&id=010066b7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010066b7",
  null
  
)

export default component.exports